import { isArray } from 'lodash'
import React from 'react'
import { useSelector } from 'react-redux'

export default function useCommunityCards(tempTableId) {
    const communityCards = useSelector((state) => state.gameTable.games[tempTableId].communityCards)

    if (!communityCards || !isArray(communityCards)) {
        return []
    }

    return communityCards
}
